import type { $Fetch } from 'ofetch';
import type { RacaGateway } from '@/application/port/out/RacaGateway';
import type { Raca } from '@/domain/model/Raca';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/racas';

export class HttpRacaGateway implements RacaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(): Promise<Raca[]> {
    const res = await this.client<ApiResponse<Raca[]>>(PATH, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
}
